import { render, staticRenderFns } from "./InvoiceSetup.vue?vue&type=template&id=4888dab5"
import script from "./InvoiceSetup.vue?vue&type=script&lang=js"
export * from "./InvoiceSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports